var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMhLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "674px",
    height: "287px",
    viewBox: "0 0 674 287",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MH_Logo_Stacked_color_cream_and_gold") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.06 0.912 263.925 0.912 263.925 56.899 0.06 56.899"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.926233385 0.044 244.36 0.044 244.36 122.94 0.926233385 122.94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MH_Logo_Stacked_color_cream_and_gold",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.096,203.602 C158.168,206.281 155.153,206.783 140.498,206.775093 C127.686,206.768 124.922,206.432 122.661,204.589 C120.568,202.829 119.9,199.814 119.903982,191.607 C119.908,183.567 120.579,180.804 122.842,179.047 C125.019,177.457 128.453,177.039 140.932,177.044937 C161.867,177.056 162.119,177.224 162.111142,191.293 C162.108,198.746 161.688,201.594 160.096,203.602 Z M164.555,164.245 C160.617,163.573 155.678,163.403 139.599,163.393893 C124.859,163.387 119.751,163.721 115.061,165.058 C108.779,166.896 105.511,170.078 103.917,176.023 C102.91,179.791 102.742,182.135 102.736947,191.515 C102.731,203.742 103.232,207.845 105.406,211.95 C107.497,216.054 111.098,218.401 117.293,219.493 C120.644,220.164 127.427,220.418 140.743,220.425081 C146.185,220.428 153.638,220.348 156.653,220.182 C164.776,219.851 169.467,218.514 172.818,215.668 C177.593,211.735 179.02,206.291 179.026071,192.809 C179.03,186.026 178.865,181.503 178.532,179.243 C177.364,170.282 173.179,165.841 164.555,164.245 L164.555,164.245 Z",
    id: "Fill-1",
    fill: "#F0E4C2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-2",
    fill: "#F0E4C2",
    points: "213.797 263.447 194.675 263.438 194.683 246.777 187.64 246.773 187.62 286.85 194.663 286.854 194.672 269.963 213.793 269.973 213.785 286.864 220.828 286.867 220.848 246.789 213.805 246.786 213.797 263.447"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-3",
    fill: "#F0E4C2",
    points: "252.503 269.822 272.599 269.831 272.602 263.534 252.507 263.524 252.512 253.103 275.183 253.115 275.186 246.817 245.472 246.802 245.452 286.879 275.454 286.894 275.457 280.596 252.498 280.585 252.503 269.822"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 163.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "#F0E4C2",
    mask: "url(#mask-2)",
    points: "263.925 1.041 247.846 1.033 248.243 43.493 214.433 1.017 187.383 1.003 187.355 56.861 203.686 56.869 203.287 14.829 236.596 56.885 263.897 56.899 263.925 1.041"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-6",
    fill: "#F0E4C2",
    mask: "url(#mask-2)",
    points: "47.325 38.036 26.993 0.926 0.028 0.912 0 56.771 16.413 56.779 15.932 13.65 40.281 56.79 53.848 56.797 78.656 13.681 77.798 56.809 94.38 56.818 94.408 0.96 67.609 0.947 47.325 38.036"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.397,109.974 L212.287,86.84 L235.42,63.73 L258.531,86.864 L235.397,109.974 Z M269.483,76.946 L244.35,51.787 C239.431,46.865 231.426,46.861 226.502,51.778 L201.344,76.912 C196.422,81.829 196.417,89.834 201.335,94.758 L226.468,119.916 C228.928,122.377 232.158,123.609 235.39,123.611002 C238.622,123.613 241.854,122.384 244.315,119.925 L269.474,94.792 C271.858,92.41 273.173,89.242 273.175002,85.871 C273.177,82.499 271.865,79.329 269.483,76.946 L269.483,76.946 Z",
    id: "Fill-8",
    fill: "#E0A42E"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-9",
    fill: "#F0E4C2",
    points: "583.896 206.656 550.086 164.18 523.037 164.166 523.008 220.024 539.339 220.033 538.94 177.993 572.248 220.048 599.549 220.062 599.578 164.204 583.498 164.197 583.896 206.656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.615,270.994 L315.493,254.967 L322.414,271 L308.615,270.994 Z M312.348,246.548 L294.694,286.904 L301.908,286.908 L306.036,277.234 L324.987,277.244 L329.046,286.921 L336.49,286.925 L318.876,246.552 L312.348,246.548 L312.348,246.548 Z",
    id: "Fill-10",
    fill: "#F0E4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.552,110.961 L415.442,87.828 L438.576,64.717 L461.685,87.851 L438.552,110.961 Z M472.635,78.933 L447.503,53.774 C442.587,48.851 434.579,48.85 429.658,53.766 L404.499,78.898 C402.114,81.281 400.799,84.449 400.797998,87.821 C400.796,91.191 402.108,94.361 404.491,96.746 L429.624,121.904 C432.082,124.365 435.313,125.597 438.545,125.599001 C441.776,125.6 445.008,124.371 447.469,121.912 L472.626,96.78 C475.012,94.397 476.327,91.229 476.329001,87.858 C476.33,84.487 475.019,81.317 472.635,78.933 L472.635,78.933 Z",
    id: "Fill-11",
    fill: "#E0A42E"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-12",
    fill: "#F0E4C2",
    points: "607.233 164.205 607.226 178.024 632.1 178.037 632.079 220.076 649.079 220.084 649.1 178.045 673.971 178.057 673.978 164.239 607.233 164.205"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-13",
    fill: "#F0E4C2",
    points: "398.149 201.205 377.817 164.096 350.852 164.082 350.824 219.941 367.237 219.949 366.755 176.82 391.105 219.96 404.671 219.967 429.48 176.851 428.623 219.979 445.204 219.988 445.232 164.13 418.433 164.117 398.149 201.205"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(271.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-14",
    fill: "#F0E4C2",
    mask: "url(#mask-4)",
    points: "198.64 33.471 241.181 33.493 241.187 22.439 198.646 22.417 198.651 12.787 243.788 12.81 243.794 0.164 181.908 0.133 181.88 55.991 244.354 56.022 244.36 43.377 198.635 43.354 198.64 33.471"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-16",
    fill: "#F0E4C2",
    mask: "url(#mask-4)",
    points: "208.307 99.579 189.185 99.571 189.193 82.91 182.15 82.906 182.13 122.983 189.173 122.987 189.182 106.096 208.303 106.106 208.295 122.996 215.338 122.999 215.358 82.922 208.315 82.918 208.307 99.579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.56,0.071 L55.547,25.697 C55.544,31.894 55.544,31.894 55.459,33.151 C55.373,37.422 54.535,39.85 52.858,41.105 C50.764,42.696 47.247,43.029 34.518,43.023 C21.79,43.016 19.025,41.758 18.192,35.477 C17.941,33.969 17.941,33.802 17.944,27.688 L17.958,0.053 L0.958,0.044 L0.943,30.108 C0.684,46.69 3.361,51.967 13.492,55.071 C17.596,56.162 20.693,56.33 36.438,56.422 L42.801,56.341 C46.152,56.343 47.66,56.343 50.255,56.261 C57.541,56.182 62.568,54.844 66.587,51.747 C71.531,47.312 72.706,43.208 72.545,29.391 L72.56,0.08 L55.56,0.071",
    id: "Fill-17",
    fill: "#F0E4C2",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-18",
    fill: "#F0E4C2",
    mask: "url(#mask-4)",
    points: "127.867 89.406 140.578 89.412 140.56 122.962 147.66 122.966 147.676 89.415 160.387 89.422 160.39 82.895 127.871 82.878 127.867 89.406"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-19",
    fill: "#F0E4C2",
    mask: "url(#mask-4)",
    points: "93.742 82.862 86.699 82.858 86.678 122.936 114.79 122.95 114.793 116.537 93.725 116.527 93.742 82.862"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.213,29.787 L297.081,4.629 C294.698,2.244 291.53,0.931 288.159,0.928997715 C284.787,0.927 281.618,2.238 279.233,4.62 L254.075,29.753 C251.69,32.135 250.376,35.304 250.374998,38.674 C250.373,42.046 251.684,45.216 254.066,47.6 L279.199,72.758 C281.581,75.143 284.749,76.457 288.121,76.4590023 C291.492,76.461 294.662,75.149 297.046,72.768 L322.204,47.634 C324.589,45.251 325.903,42.083 325.905002,38.712 C325.907,35.341 324.595,32.172 322.213,29.787",
    id: "Fill-21",
    fill: "#E0A42E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(301.000000, 0.000000)",
    fill: "#E0A42E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.875,79.014 L46.743,53.855 C41.824,48.933 33.82,48.929 28.895,53.846 L3.738,78.979 C1.353,81.361 0.039,84.53 0.036997715,87.901 C0.035,91.272 1.346,94.442 3.728,96.827 L28.861,121.984 C31.321,124.446 34.551,125.678 37.783,125.679002 C41.014,125.681 44.248,124.452 46.708,121.993 L71.867,96.861 C74.252,94.478 75.566,91.31 75.5680023,87.939 C75.57,84.567 74.258,81.398 71.875,79.014",
    id: "Fill-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.715,28.965 L96.583,3.807 C91.667,-1.115 83.659,-1.118 78.738,3.798 L53.58,28.931 C51.194,31.313 49.879,34.482 49.8779977,37.853 C49.876,41.224 51.188,44.394 53.57,46.778 L78.704,71.938 C81.163,74.398 84.393,75.628 87.624,75.6300024 C90.856,75.632 94.088,74.404 96.549,71.946 L121.707,46.812 C126.63,41.894 126.634,33.889 121.715,28.965",
    id: "Fill-24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhLogo);
export default __webpack_public_path__ + "static/media/mh-logo.8ffbdcbd4cbbe420a46b711f88eba77a.svg";
export { ForwardRef as ReactComponent };